module.exports = __webpack_public_path__ + "static/media/Maths.6dd8ef74.gif";